<button *ngIf="motor.start" class="btn btn-primary text-white mr-1 w-50" (click)="on()">{{motor.start.label ? motor.start.label : "Accendi" }}</button>
<button *ngIf="motor.stop" class="btn btn-primary text-white ml-1 w-50" (click)="off()">{{motor.stop.label ? motor.stop.label : "Spegni" }}</button>
